import React from "react";
import CircularRedCloseIcon from "../Assets/svgs/CircularRedCloseIcon";
import ExcelIcon from "../Assets/svgs/ExcelIcon";
import FileIcon from "../Assets/svgs/FileIcon";

export const PreviewImportError = ({
  fileName,
  errorsData,
  onClose,
  onPressTryAgain,
}) => {
  return (
    <div className="modal modal--previewCsvWarning modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <h4 className="modal__header--title">Upload CSV</h4>
          </div>
          <div className="modal__body modal-body-left">
            <h3 className="form__label form__label--csv">
              <ExcelIcon height={"27"} width={"27"} />
              {fileName}
            </h3>
            <div className="previewCsvError">
              <div className="previewCsvError__row">
                <div className="previewCsvError__item">
                  <div className="icon">
                    <CircularRedCloseIcon />
                  </div>
                  <div className="detail">
                    <h3>
                      There are multiple errors in the excel file that has been
                      uploaded.
                    </h3>
                    <p>• Error in the table are specified below </p>
                    <h4>Try uploading the file again</h4>
                  </div>
                </div>
              </div>
              <div className="previewCsvError__row">
                <h3 className="previewCsvError__title">Errors*</h3>
                <ul className="previewCsvError__list">
                  {Array.isArray(errorsData) &&
                    errorsData?.map((error, errorIndex) => (
                      <li
                        key={`row-error-${errorIndex}-${error?.rowNumber}`}
                        className="previewCsvError__list__item"
                      >
                        <p className="para">
                          <span className="icon">
                            <FileIcon />
                          </span>
                          Row Number: {error?.rowNumber}
                        </p>
                        <p className="para">
                          <span className="icon">
                            <CircularRedCloseIcon width="15" height="15" />
                          </span>
                          Error: {error?.errorMessages}
                        </p>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="modal__footer modal__footer--center">
            <div className="btn__group">
              <button className="btn btn__secondary" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn__primary" onClick={onPressTryAgain}>
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
